import { guestsBasePath, guestsCreatePath } from '../../../routes/Paths';

export const NAV_KEYS = {
  CREATE: 'create-nav',
  LIST: 'list-nav'
};

export const navKeysByPath = {
  [guestsCreatePath]: NAV_KEYS.CREATE,
  [guestsBasePath]: NAV_KEYS.LIST
};
